<div class="container">
  <monitor-header
    class="container-section"
    [id]="id">
  </monitor-header>

  <detail-data-table
    *ngIf="((actionSet?.actions ?? []).length > 0) && ((actionSet?.actions ?? []) | haveOneAction : ['ACT_MONITOR_DETAIL'])"
    class="container-section"
    [apiParent]="'monitor'"
    [apiUrl]="'monitor-detail/monitor-detail'"
    [titlePage]="'TITLE_CONTAINER_DETAILS'"
    [pageId]="'PAG_MONITOR_DETAIL'"
    [id]="id"
  ></detail-data-table>

  <monitor-detail-attachment
    *ngIf="((actionSet?.actions ?? []).length > 0) && ((actionSet?.actions ?? []) | haveOneAction : ['ACT_MONITOR_ATTACHMENT'])"
    [id]="id"
    [container] = "container"
    [apiParent]="'monitor'"
    [apiUrl]="'monitor-detail/monitor-attachment'"
    class="container-section">
  </monitor-detail-attachment>

  <detail-data-table
    *ngIf="((actionSet?.actions ?? []).length > 0) && ((actionSet?.actions ?? []) | haveOneAction : ['ACT_MONITOR_INV_PARTY'])"
    class="container-section"
    [apiParent]="'monitor'"
    [apiUrl]="'monitor-detail/monitor-inv-party'"
    [titlePage]="'TITLE_INVOLVED_PARTY'"
    [pageId]="'PAG_MONITOR_INV_PARTY'"
    [id]="id"
  ></detail-data-table>

  <detail-data-table
    *ngIf="((actionSet?.actions ?? []).length > 0) && ((actionSet?.actions ?? []) | haveOneAction : ['ACT_MONITOR_EVENT'])"
    class="container-section"
    [apiParent]="'monitor'"
    [apiUrl]="'monitor-detail/monitor-events'"
    [titlePage]="'TITLE_EVENTS'"
    [pageId]="'PAG_MONITOR_EVENT'"
    [id]="id"
  ></detail-data-table>

  <detail-data-table
    *ngIf="((actionSet?.actions ?? []).length > 0) && ((actionSet?.actions ?? []) | haveOneAction : ['ACT_MONITOR_COST'])"
    class="container-section"
    [apiParent]="'monitor'"
    [apiUrl]="'monitor-detail/monitor-cost'"
    [titlePage]="'TITLE_COSTS'"
    [pageId]="'PAG_MONITOR_COST'"
    [id]="id"
  ></detail-data-table>

  <div mat-dialog-actions align="end">
    <button mat-button color="primary" [mat-dialog-close]="false">{{"ACT_CLOSE" | translate}}</button>
  </div>

</div>

